import useGetExternalProperty from 'hooks/services/externalProperty/useGetExternalProperty';
import { CSSProperties, MouseEventHandler, useMemo } from 'react';
import { ExternalProperty } from 'crono-fe-common/types/externalProperty';
import { useAuth } from 'context/auth';
import { doesCrmSupportLeads } from 'crono-fe-common/utils/crm-utils';
import { TagsBoxShowAllView } from './TagsBoxShowAllView';

interface IProps {
  // The type of tags that we want to show, Account, prospect and leads, Account and prospects/lead related, opportunity or all of them
  type:
    | 'Account'
    | 'Prospect'
    | 'Lead'
    | 'AccountAndProspect'
    | 'Opportunity'
    | 'All';
  onlyInsert?: boolean;
  currentSituation?: (string | null)[];
  handleClickTag?: (
    option: string | null,
    externalProperty: ExternalProperty,
    index: number,
  ) => void;
  //If this is set to true, it means that the tags marked as isEditable false should be disabled (because we
  // are in accout/prospect page for example).
  // This is false by default, because for strategies and templates we want to show and edit all the tags, even if they are not editable
  blockIsEditable?: boolean;
  //If true we do not allow edit. Default false
  disableEdit?: boolean;
  //If the currents are tags maybe already selected, not a screen
  //from which I always start empty (such inserts)
  currentSituationTags?: { externalPropertyId: number; option: string }[];

  showRemovable?: boolean;

  //If true, the mandatory tags will be shown with a star
  showMandatoryAsStar?: boolean;

  whiteBackground?: boolean;
  customStyle?: CSSProperties;

  disabledIds?: number[];
  disabledTooltip?: string;

  //If set, shows only the first N tags and displays +n for remaining tags
  collapseAfter?: number;
  onClick?: MouseEventHandler<HTMLDivElement>;
  className?: string;
}

const TagsBoxShowAll = ({ type, onlyInsert, ...viewProps }: IProps) => {
  const { user } = useAuth();
  const { data: tagsDb } = useGetExternalProperty({
    tableType:
      type === 'All' || type === 'AccountAndProspect'
        ? null
        : type === 'Lead' &&
            !doesCrmSupportLeads(user?.company?.integrationType)
          ? 'Prospect'
          : type,
    onlyTag: true,
    onlyInsert: onlyInsert === true ? true : null,
    withLead: type === 'Opportunity' ? true : null,
    enabled: true,
  });

  const tags = useMemo(() => {
    if (!tagsDb?.data?.data) return [];
    let tagsToReturn = tagsDb.data.data;
    if (type === 'AccountAndProspect') {
      tagsToReturn = tagsDb.data.data.filter(
        (tag) =>
          tag.tableType === 'Account' ||
          tag.tableType === 'Prospect' ||
          tag.tableType === 'Lead',
      );
    } else if (type === 'Opportunity') {
      tagsToReturn = tagsDb.data.data.filter(
        (tag) => tag.tableType === 'Opportunity',
      );
    }
    return tagsToReturn;
  }, [tagsDb, type]);

  return <TagsBoxShowAllView tags={tags} {...viewProps} />;
};
export default TagsBoxShowAll;
